module.exports = __webpack_public_path__ + "static/media/ic_mask_stop.f2b84ad3.svg";